export default "__VITE_ASSET__tMH$QUYw__"